import { render } from "./Home.vue?vue&type=template&id=80a36974&ts=true"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import exportComponent from "/root/workspace/__flow_work/__flow_builds/1fe6d5c2-02f8-4b7b-a7ed-3827401bba29/workspace/toilet-go-front_Ak2Q/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__